var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticClass: "v-menu",
      attrs: {
        left: "",
        origin: "center center",
        transition: "scale-transition",
        "data-testid":
          (_vm.params.testId ? _vm.params.testId + "__" : "") + "MenuItem"
      }
    },
    [
      _c(
        "v-btn",
        { attrs: { slot: "activator", icon: "" }, slot: "activator" },
        [_c("v-icon", { attrs: { color: "#526da5" } }, [_vm._v("more_vert")])],
        1
      ),
      _c(
        "v-list",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mostrarMenuAcciones,
              expression: "mostrarMenuAcciones"
            }
          ]
        },
        [
          _vm.btnEnviarComando
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EnviarComando
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EnviarComando)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnEnviarComandoText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerDetalle
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.VerDetalle)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("info")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerDetalle)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnVerDetalleText))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }